import React, { useEffect, useState, useRef } from 'react'
import './BottomNav.css'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faTowerBroadcast, faDollarSign, faCommentDots, faUserAlt } from '@fortawesome/free-solid-svg-icons'
import { getAuth } from 'firebase/auth'
import { getDatabase, ref, onValue } from 'firebase/database'

function BottomNav() {
  const auth = getAuth()
  const rtdb = getDatabase()
  const [unreadCount, setUnreadCount] = useState(0)
  const prevUnreadRef = useRef(0)

  useEffect(() => {
    const user = auth.currentUser
    if (!user) return

    const chatsRef = ref(rtdb, 'chats')
    const lastReadRef = ref(rtdb, 'lastRead')

    let chatsData = {}
    let lastReadData = {}

    const calculateUnread = () => {
      let count = 0
      Object.keys(chatsData).forEach(chatId => {
        if (!chatId.includes(user.uid)) return
        const messages = Object.values(chatsData[chatId] || {})
        const lastRead = lastReadData?.[chatId]?.[user.uid] || 0
        messages.forEach(msg => {
          if (msg.receiverId === user.uid && msg.timestamp > lastRead) count += 1
        })
      })

      prevUnreadRef.current = count
      setUnreadCount(count)
    }

    const unsubChats = onValue(chatsRef, snap => {
      chatsData = snap.val() || {}
      calculateUnread()
    })

    const unsubLastRead = onValue(lastReadRef, snap => {
      lastReadData = snap.val() || {}
      calculateUnread()
    })

    return () => {
      unsubChats()
      unsubLastRead()
    }
  }, [auth, rtdb])

  return (
    <div className="bottomNav">
      <NavLink to="/dashboard" className="bottomNavLink">
        <FontAwesomeIcon icon={faBars} />
        <span>Home</span>
      </NavLink>
      <NavLink to="/campaigns" className="bottomNavLink">
        <FontAwesomeIcon icon={faTowerBroadcast} />
        <span>Campaigns</span>
      </NavLink>
      <NavLink to="/earnings" className="bottomNavLink">
        <FontAwesomeIcon icon={faDollarSign} />
        <span>Earnings</span>
      </NavLink>
      <NavLink to="/messages" className="bottomNavLink" style={{ position: 'relative' }}>
        <FontAwesomeIcon icon={faCommentDots} />
        <span>Messages</span>
        {unreadCount > 0 && (
          <span className="messageBadgeBottom">{unreadCount}</span>
        )}
      </NavLink>
      <NavLink to="/profile" className="bottomNavLink">
        <FontAwesomeIcon icon={faUserAlt} />
        <span>Profile</span>
      </NavLink>
    </div>
  )
}

export default BottomNav